import { globalEndpoints } from 'constants/global.constants';

const RECAPTCHA_SCRIPT_ID = 'one-digital-recaptcha-v3';
let recaptchaReadyPromise: Promise<void> | null = null;

export const loadReCaptchaScript = (): Promise<void> => {
	if (typeof window === 'undefined') {
		return Promise.resolve();
	}

	if (recaptchaReadyPromise) {
		return recaptchaReadyPromise;
	}

	recaptchaReadyPromise = new Promise((resolve, reject) => {
		const onReady = () => {
			const grecaptcha = (window as any).grecaptcha;
			if (!grecaptcha?.ready) {
				reject(new Error('reCAPTCHA did not initialize'));
				return;
			}

			grecaptcha.ready(() => resolve());
		};

		const existingScript = document.getElementById(RECAPTCHA_SCRIPT_ID) as HTMLScriptElement | null;
		if (existingScript) {
			if ((window as any).grecaptcha) {
				onReady();
				return;
			}

			existingScript.addEventListener('load', onReady, { once: true });
			existingScript.addEventListener('error', () => reject(new Error('Failed to load reCAPTCHA script')), {
				once: true,
			});
			return;
		}

		const script = document.createElement('script');
		script.id = RECAPTCHA_SCRIPT_ID;
		script.src = `https://www.google.com/recaptcha/api.js?render=${globalEndpoints.REACT_APP_RECAPTCHA_CLIENT_SECRET}`;
		script.async = true;
		script.defer = true;
		script.onload = onReady;
		script.onerror = () => reject(new Error('Failed to load reCAPTCHA script'));
		document.body.appendChild(script);
	});

	return recaptchaReadyPromise.catch((error) => {
		recaptchaReadyPromise = null;
		throw error;
	});
};
